import { render, staticRenderFns } from "./deptManage.vue?vue&type=template&id=f944b1fa&scoped=true&"
import script from "./deptManage.vue?vue&type=script&lang=js&"
export * from "./deptManage.vue?vue&type=script&lang=js&"
import style0 from "./deptManage.vue?vue&type=style&index=0&id=f944b1fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f944b1fa",
  null
  
)

export default component.exports